import React, { useEffect, useState } from "react";
import { X } from "lucide-react";

export interface Toast {
  id: string;
  title: string;
  type?: "success" | "error" | "info";
  duration?: number;
}

interface ToastProps {
  toast: Toast;
  onRemove: (id: string) => void;
}

const ToastComponent: React.FC<ToastProps> = ({ toast, onRemove }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Animar entrada
    const timer = setTimeout(() => setIsVisible(true), 100);
    
    // Auto remover após duração
    const autoRemoveTimer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => onRemove(toast.id), 300);
    }, toast.duration || 3000);

    return () => {
      clearTimeout(timer);
      clearTimeout(autoRemoveTimer);
    };
  }, [toast.id, toast.duration, onRemove]);

  const handleRemove = () => {
    setIsVisible(false);
    setTimeout(() => onRemove(toast.id), 300);
  };

  const getToastStyles = () => {
    switch (toast.type) {
      case "success":
        return "bg-white text-[#00A70E] border border-[#00A70E]";
      case "error":
        return "bg-white text-red-600 border border-red-600";
      case "info":
      default:
        return "bg-white text-blue-600 border border-blue-600";
    }
  };

  return (
    <div
      className={`
        ${getToastStyles()}
        px-4 py-3 rounded-lg shadow-lg
        flex items-center justify-between
        min-w-[300px] max-w-[400px]
        transform transition-all duration-300 ease-in-out
        ${isVisible 
          ? "translate-x-0 opacity-100" 
          : "translate-x-full opacity-0"
        }
      `}
    >
      <span className="font-medium text-sm">{toast.title}</span>
      <button
        onClick={handleRemove}
        className="ml-3 p-1 hover:bg-gray-100 rounded-full transition-colors"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default ToastComponent;
